__turbopack_context__.v({
  "mailLink": "footer-module-scss-module__HOVWDq__mailLink",
});
